import { LinkButton } from "@/ui/next/LinkButton";
import { useTranslation } from "next-i18next";

import { useAuth } from "@/auth";
import { analyticsService } from "@/common/services/analytics/analytics.service";
import { ACCOUNT_FAVORITES_ROUTE } from "@/common/static/routes.static";
import { useHomepageFavoriteProducts } from "@/components/Homepage/hooks/useHomepageFavoriteProducts.hooks";
import { ProductCard } from "@/features/search/components/product-card/ProductCard";
import { toCardProduct } from "@/features/search/utils/gateway-product.utils";
import { Heading } from "@/ui/cva/Heading";

export const HomepageFavoritesBlock = () => {
  const { t } = useTranslation();
  const { isLoggedIn } = useAuth();
  const { favorites } = useHomepageFavoriteProducts();

  const handleSeeAllClick = () => {
    /** Trigger `hp_favourites` event. */
    analyticsService.trackHpFavorites();
  };

  if (!isLoggedIn || !favorites.length) {
    return null;
  }

  return (
    <section className="flex flex-col items-center space-y-6">
      <div className="flex flex-col items-center">
        <Heading as="h2" size="h3" className="text-center">
          {t("home:homepage-user-favorites-title")}
        </Heading>
        <LinkButton
          href={ACCOUNT_FAVORITES_ROUTE}
          appearance="minimal"
          onClick={handleSeeAllClick}
        >
          {t("home:homepage-user-favorites-link")}
        </LinkButton>
      </div>
      <div className="grid w-full grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
        {favorites.map(product => (
          <ProductCard key={product.id} product={toCardProduct(product)} />
        ))}
      </div>
    </section>
  );
};
